import { Button, Card } from 'react-bootstrap';
import './WorkflowStartNode.css'
import { useDispatch, useSelector } from 'react-redux';
import { workflowAction } from '../../../store/workflow';
import { useState } from 'react';
import Popup from '../../../components/Popup/Popup';
import Helper from '../../../inc/Helper';

const WorkflowStartNode = (props) => {

  const propsNodeId = props.nodeData.target.dataset;
  // const dispatch = useDispatch();
  // const isClose = useSelector((state) => state.workflowSlice.isOpend);
  // console.log(isClose);
  // const modalOpen = (ev) => {
  //   if (!isClose) {
  //     dispatch(workflowAction.open(ev.target.value));
  //   }
  // }
  
  const modalOpen = (ev) => {
    if (ev.target.value === '1') { 
      props.getActionValue(ev.target.value);
      props.openConditionalModal(true);
    }
    if (ev.target.value === '2') {
      props.getActionValue(ev.target.value);
      props.openActionModal(true);
    }
    if (ev.target.value === '3') {
      props.getActionValue(ev.target.value);
      props.openTaskModal(true);
    }
    if (ev.target.value === '4') {
      props.getActionValue(ev.target.value);
      props.openSubworkflowModal(true);
    }
  }

  // const [startNodeModal, setStartNodeModal] = useState(false);
  const closeIconUrl = '/images/icons/cross.svg';
  const closeStartModal = () => {
    props.del(false);
    // setStartNodeModal(false);
  }

  return (
    <>
      {/* {!startNodeModal ? */}
      <Popup width="900px" onClose={closeStartModal} autoOpen={true} >
        <div className='d-flex justify-content-between'>
          <Card className='p-1'>
            <Card.Header className='card-header bg-green'>Condition</Card.Header>
            <Card.Body className='card-body'>
              <Card.Text>
                Define the criteria directing task distribution.
              </Card.Text>
              <Button className='card-button text-green' value={1} onClick={modalOpen}>Select</Button>
            </Card.Body>
          </Card>
          <Card className='p-1 mx-1'>
            <Card.Header className='card-header bg-blue'>Action</Card.Header>
            <Card.Body>
              <Card.Text>
                Automated responses upon successful task completion.
              </Card.Text>
              <Button className='card-button text-blue' value={2} onClick={modalOpen} >Select</Button>
            </Card.Body>
          </Card> 
          {/* <Card className='p-1'>
          <Card.Header className='card-header bg-orange'>Fields</Card.Header>
          <Card.Body>
            <Card.Text>
              Lorem Ipsum is simply dummy text of the printing
            </Card.Text>
            <Button className='card-button text-orange' value={3} onClick={modalOpen} >Select</Button>
          </Card.Body>
        </Card> */}
          <Card className='p-1'>
            <Card.Header className='card-header bg-orange'>Task</Card.Header>
            <Card.Body>
              <Card.Text>
                Empower users or teams with specific action assignments.
              </Card.Text>
              <Button className='card-button text-orange' value={3} onClick={modalOpen} >Select</Button>
            </Card.Body>
          </Card>
          <Card className='p-1 mx-1'>
            <Card.Header className='card-header bg-teal'>Sub-Workflow</Card.Header>
            <Card.Body>
              <Card.Text>
                Launch a linked workflow to handle related processes or detailed steps.
              </Card.Text>
              <Button className='card-button text-teal' value={4} onClick={modalOpen} >Select</Button>
            </Card.Body>
          </Card>
          {/* <div className='rs_popup_close' onClick={closeStartModal} > <img src={closeIconUrl} alt="Close" /> </div> */}
        </div>
        {/* : []} */}
      </Popup>
    </>
  )
}

export default WorkflowStartNode;